import { render, staticRenderFns } from "./ClassTooltipDetail.vue?vue&type=template&id=671b1bd9&"
import script from "./ClassTooltipDetail.vue?vue&type=script&lang=js&"
export * from "./ClassTooltipDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports